export const bonuses = [
  {
    number: 1,
    color: '#1D6FD8',
    image: 'https://cdn.magicpatterns.com/uploads/ayhxvgMt16qKRyqknDdmbV/BONUS_1_PAIN-EN.png',
    title: 'The Low Back Pain Initial Assessment Checklist',
    description: 'A structured checklist to help you organize the main components of an initial low back pain assessment.',
    listLabel: 'Use it to review:',
    items: [
      'Presenting complaint and symptom history.',
      'Relevant medical background.',
      'Functional limitations.',
      'Important screening questions.',
      'Examination planning.',
      'Documentation and follow-up considerations.',
    ],
    note: 'Designed to support a consistent process without replacing individualized clinical judgment.',
  },
  {
    number: 2,
    color: '#DC2626',
    image: 'https://cdn.magicpatterns.com/uploads/jJVgqpo9vXRSyG1mDVQoBm/BONUS_2_PAIN-EN.png',
    title: 'The Lumbar Red Flag Screening Worksheet',
    description: 'A practical worksheet for organizing relevant symptoms, historical findings, concerning changes, and decisions about further evaluation.',
    listLabel: 'Use it to document:',
    items: [
      'Relevant patient-reported symptoms.',
      'Important historical findings.',
      'Changes in symptom presentation.',
      'Neurological concerns.',
      'Reasons to consider additional medical evaluation.',
      'Referral and escalation considerations.',
    ],
    note: 'The worksheet supports documentation and clinical reasoning. It is not a standalone screening test or a substitute for emergency procedures.',
  },
  {
    number: 3,
    color: '#0F8A6A',
    image: 'https://cdn.magicpatterns.com/uploads/oM1AqsTQMiNbzXqUf5HKXk/BONUS_3_PAIN-EN.png',
    title: 'The Lumbar Examination Quick Reference',
    description: 'A compact reference to help you organize the main components of a lumbar spine examination.',
    listLabel: 'Review considerations involving:',
    items: [
      'Observation and functional movement.',
      'Lumbar mobility.',
      'Relevant neurological examination.',
      'Lower-extremity symptoms.',
      'Selection of physical examination procedures.',
      'Documentation of findings.',
    ],
    note: 'Use it to structure your review of the examination process without treating any single test as definitive.',
  },
  {
    number: 4,
    color: '#7C3AED',
    image: 'https://cdn.magicpatterns.com/uploads/aiQJehRKwx2bKZUcASoZVL/BONUS_4_PAIN-EN.png',
    title: 'The Low Back Pain Clinical Reasoning Matrix',
    description: 'A structured worksheet for organizing the information collected during an assessment.',
    listLabel: 'Use the matrix to record:',
    items: [
      'Relevant subjective findings.',
      'Physical examination results.',
      'Potential working hypotheses.',
      'Findings that support or challenge each hypothesis.',
      'Information that remains missing.',
      'Reasons to consider further investigation or referral.',
    ],
    note: 'The objective is to make your reasoning more transparent, organized, and easier to document.',
  },
  {
    number: 5,
    color: '#EA580C',
    image: 'https://cdn.magicpatterns.com/uploads/is3JUTMQZS5Ht8VpfbkQZ5/BONUS_5_PAIN-EN.png',
    title: 'The Low Back Pain Case Review Workbook',
    description: 'An educational workbook that helps you practice applying the assessment framework to hypothetical clinical presentations.',
    listLabel: 'Each exercise encourages you to:',
    items: [
      'Review the presenting complaint.',
      'Identify relevant information.',
      'Organize examination findings.',
      'Recognize potentially concerning features.',
      'Consider alternative explanations.',
      'Identify missing information.',
      'Explain your reasoning.',
    ],
    note: 'Designed to reinforce learning through practice rather than passive reading alone.',
  },
];
